import { AodRun } from '@app/modules/audit/modules/aod/aod.types';
import { useAodFactory } from '../screens/aod-rules-add/custom/AodFactory';

export function AodRunActions({ run }: { run: AodRun }) {
  const {
    views: { RunActions },
  } = useAodFactory(run.rule.reportType);

  if (!RunActions) {
    return null;
  }

  return <RunActions run={run} />;
}
